import { COMPANY_CONFIGS } from "@/config/companies";
import { CompanyLogin } from "@/components/company-portal/CompanyLogin";

export default function InnoventureLogin() {
  const config = COMPANY_CONFIGS.innoventure;
  return <CompanyLogin config={config} />;
}
